import { render, staticRenderFns } from "./ShortVideoEdit.vue?vue&type=template&id=413eda86&scoped=true"
import script from "./ShortVideoEdit.vue?vue&type=script&lang=js"
export * from "./ShortVideoEdit.vue?vue&type=script&lang=js"
import style0 from "./ShortVideoEdit.vue?vue&type=style&index=0&id=413eda86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413eda86",
  null
  
)

export default component.exports